var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.195,
    height: 17,
    viewBox: "0 0 18.195 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logout",
    d: "M13.917,2H6.289A2.43,2.43,0,0,0,4,4.55V7.1a.81.81,0,0,0,.763.85.81.81,0,0,0,.763-.85V4.55a.81.81,0,0,1,.763-.85h7.629a.81.81,0,0,1,.763.85v11.9a.81.81,0,0,1-.763.85H6.289a.81.81,0,0,1-.763-.85v-3.4a.81.81,0,0,0-.763-.85A.81.81,0,0,0,4,13.05v3.4A2.43,2.43,0,0,0,6.289,19h7.629a2.43,2.43,0,0,0,2.289-2.55V4.55A2.43,2.43,0,0,0,13.917,2Z",
    transform: "translate(1.239 -2)",
    fill: "#979899"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(0 5.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M-1208.277-4162.449l-3.393,3.225,3.393,3.225",
    transform: "translate(1211.671 4162.449)",
    fill: "none",
    stroke: "#979899",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M-1198.711-4158.737h-11.477",
    transform: "translate(1210.62 4161.962)",
    fill: "none",
    stroke: "#979899",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.409f0a80ab09f5c8327d1aec230bc5e6.svg";
export { ForwardRef as ReactComponent };